import MapListSwitcher from './MapListSwitcher';

export default MapListSwitcher;
